/**
 * Momento exacto en que se va a marcar la salida.
 *
 * Lleva el día además de la hora porque un turno que cruza medianoche termina
 * al día SIGUIENTE: un "06:00" a secas se lee como el mismo día, y quien
 * revisa no tiene forma de notar la diferencia. Cuando el día no es el de la
 * jornada se resalta, que es el caso donde equivocarse cuesta.
 */

import type { JornadaDto } from '../../api';
import { aDdMmAaaa } from '../../lib/fechas';

export function SalidaAMarcar({ jornada: j }: { readonly jornada: JornadaDto }): React.JSX.Element {
  // Ya fichó salida: no hay nada que marcar (§12.4). Se dice por qué, y no con
  // un guion: un guion acá se lee como "falta el dato".
  if (j.fichadaSalida) {
    return <span className="nota">ya fichó salida</span>;
  }

  if (!j.horaSalidaCalculada || !j.fechaSalidaCalculada) return <>—</>;

  const otroDia = j.fechaSalidaCalculada !== j.fechaOperativa;
  return (
    <span className="salida" {...(otroDia ? { 'data-otro-dia': 'si' } : {})}>
      <span className="salida-dia">{aDdMmAaaa(j.fechaSalidaCalculada)}</span> {j.horaSalidaCalculada}
      {otroDia && <span className="salida-aviso"> (día siguiente)</span>}
    </span>
  );
}
